import cart from '@motionelements/core/src/store/modules/cart.js';

export default {
  namespaced: true,
  state: () => cart.state,
  getters: cart.getters,
  actions: cart.actions,
  mutations: cart.mutations,
};
